import React from "react";
import { Box, Typography } from "@mui/material";
import { Colors } from "../../Constants/Colors";
import moment from "moment";

const steps = [
  { label: "Query registered with team", date: "16 Mar 2025" },
  { label: "Team shared the resolution" },
  { label: "Approved by patient" },
];

interface VerticalStepperProps {
  activeStep: number;
  querySteps: Array<{ label: string; date?: string }>;
}

const getStepStyle = (index: number, activeStep: number) => {
  if (index <= activeStep)
    return {
      dotColor: Colors.greenBorderColor,
      lineColor: Colors.greenBorderColor,
    }; // completed and active
  return { dotColor: "#999999", lineColor: Colors.primaryTextColor }; // upcoming
};

export default function CustomVerticalStepper({querySteps, activeStep = 0}: VerticalStepperProps) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", ml: 2 }}>
      {querySteps.map((step, index) => {
        const { dotColor, lineColor } = getStepStyle(index, activeStep);
        return (
          <Box key={index} sx={{ display: "flex", alignItems: "flex-start" }}>
            {/* Left side - dot and line */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                mr: 2,
              }}
            >
              {/* Dot */}
              <Box
                sx={{
                  width: 16,
                  height: 16,
                  borderRadius: "50%",
                  backgroundColor: dotColor,
                  border: `4px solid ${
                    index <= activeStep ? "#E0F2F1" : Colors.grey
                  }`,
                }}
              />
              {/* Line */}
              {index !== steps.length - 1 && (
                <Box
                  sx={{
                    width: 2,
                    flexGrow: 1,
                    height: "30px",
                    mt: 0.5,
                    backgroundImage: `linear-gradient(to bottom, ${lineColor} 33%, transparent 0%)`,
                    backgroundSize: "1.5px 6px",
                    backgroundRepeat: "repeat-y",
                  }}
                ></Box>
              )}
            </Box>

            {/* Right side - text */}
            <Box>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: 1,
                  color:
                    index <= activeStep ? Colors.primaryTextColor : "#9E9E9E",
                }}
              >
                {step.label}
              </Typography>
              {step.date && (
                <Typography
                  sx={{
                    fontSize: "10px",
                    fontWeight: 400,
                    mt: "4px",
                    color: Colors.lightGrey,
                  }}
                >
                  {moment(step?.date).format("DD MMM YYYY")}
                </Typography>
              )}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}
